const myStyles = theme => ({
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(3),
    flexBasis: "400px"
  },

  form: {
    width: "100%",
    marginTop: theme.spacing(2)
  },

  link: {
    color: "#0288D1",
    display: "block",
    marginBottom: theme.spacing(2)
  }
});

export default myStyles;
